<div class="top">
  <div class="heading">
      <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;">{{this.dialogData?.displayName || 'SUPER AGENT'}}</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
      close
  </i>
</div>


<div class="form-wrapper">

  <form [formGroup]="form">

    <div class="form-section">
      <h5 class="form-section-heading mb-3">CHILD'S INFORMATION:</h5>
      <div class="body">
        <div class=" row g-3">
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">SURNAME</label>
              <input type="text" placeholder="Enter surname" class="form-control mt-0" formControlName="surname"
                maxlength="60" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">FIRST NAME</label>
              <input type="text" placeholder="Enter first name" class="form-control mt-0" formControlName="firstName"
                maxlength="60" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">MIDDLE NAME</label>
              <input type="text" placeholder="Enter middle name" class="form-control mt-0" formControlName="middleName"
                maxlength="60" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">DATE OF BIRTH</label>
              <input type="date" class="form-control mt-0" formControlName="dob" />

            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">GENDER</label>
              <select class="form-control small-option-font" formControlName="gender">
                <option value="">-- Select--</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
            </select>

            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">ORDER OF BIRTH</label>
              <input type="text" placeholder="e.g. 09087763552" class="form-control mt-0"
                formControlName="orderOfBirth" maxlength="17" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">TYPE OF BIRTH</label>
              <select class="form-control small-option-font" formControlName="typeOfBirth">
                <option value="">-- Select--</option>
                <option value="Cesarean Section">Cesarean Section</option>
                <option value="Natural Birth">Natural Birth</option>
            </select>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">PLACE OF BIRTH</label>
              <input type="text" placeholder="Enter Address" class="form-control mt-0" formControlName="placeOfBirth"
                maxlength="200" />

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="field">
              <label class="mb-0 required">TIME OF BIRTH</label>
              <input type="time" class="form-control mt-0" formControlName="timeOfBirth"/>

            </div>
          </div>

        </div>
      </div>
    </div>


    <div class="table-wrapper mt-3">
      <table class="role-table amc-table" appAutoDataLabel>
        <thead class="amc-table-heading">
          <tr>
            <th class="ps-4">Type</th>
            <th>Name</th>
            <th>Phone Number</th>
            <th>Address</th>

          </tr>
        </thead>

        <tbody>

          <tr *ngFor="let item of  dialogData?.parents; let i = index">
            <td>{{ item?.parentType}}</td>
            <td>{{ item?.firstName + " " + item?.lastName  | titlecase }}</td>
            <td>{{ item?.phoneNumber | titlecase }}</td>
            <td>{{ item?.address | titlecase }}</td>
          </tr>


        </tbody>
      </table>
    </div>


  </form>


</div>

<div class="modal-actions-wrapper"
    *ngIf="hasAccess(['CAN_APPROVE_BIRTH_REGISTRATION']) && dialogData?.approvalStatus == 'PENDING' ">
    <button type="submit" class="btn flex-btn btn-danger w-100" (click)="queryApplication()">
        <span>DECLINE</span>
        <span class="spinner-light" *ngIf="isQueryingApplication"></span>
    </button>

    <button type="submit" class="btn flex-btn btn-success w-100" (click)="approveApplication()">
        <span>APPROVE</span>
        <span class="spinner-light" *ngIf="isApprovingApplication"></span>
    </button>
</div>